
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';

function DecisoesFormPage() {
  const [nome, setNome] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const { id } = useParams();

  const pageTitle = id ? 'Editar Decisão' : 'Nova Decisão';
  const pageSubtitle = id ? `Editando o registro #${id}` : 'Preencha os dados para criar uma nova decisão';

  // Busca os dados da decisão para edição
  useEffect(() => {
    if (id) {
      setLoading(true);
      api.get(`/decisoes/${id}`)
        .then(response => {
          const { nome } = response.data.data;
          setNome(nome);
        })
        .catch(err => {
          setError('Não foi possível carregar os dados da decisão.');
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);

  // Envia os dados do formulário (criação ou atualização)
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    const decisaoData = { nome };

    try {
      if (id) {
        await api.put(`/decisoes/${id}`, decisaoData);
      } else {
        await api.post('/decisoes', decisaoData);
      }
      navigate('/painel/decisoes');
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('Ocorreu um erro ao salvar a decisão. Verifique os dados.');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading && id) {
    return (
      <div className="decisoes-form-page">
        <p>Carregando dados da decisão...</p>
      </div>
    );
  }

  return (
    <div className="decisoes-form-page">
      <div className="content-header">
        <h1 className="content-title">{pageTitle}</h1>
        <p className="content-subtitle">{pageSubtitle}</p>
      </div>

      <div className="card decisoes-form-card">
        <div className="card-body">
          <form className="decisoes-form" onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="mb-3">
              <label htmlFor="nome" className="form-label">Nome</label>
              <input
                type="text"
                className="form-control"
                id="nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required
              />
            </div>

            <div className="decisoes-form-actions d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={() => navigate('/painel/decisoes')}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default DecisoesFormPage;
